import { z } from 'zod';

import { GuardianLabelSchema } from '../guardian-label/guardian-label';

/**
 * Issue a code for a guardian.
 *
 * One field, and it is **required**: a ward who may hold several guardians must
 * name each one at the moment she creates it, or her list becomes a column of
 * identical rows she has to revoke by guesswork — and revoking the wrong one is
 * this feature's most expensive mistake.
 *
 * The deadline is **not** a parameter. `guardian.inviteTtlHours` is the
 * operator's (U9), and letting a client name it would make the one bound on how
 * long a bearer credential stays live a thing the caller chooses.
 *
 * `.strict()` (N7): an extra key is a client bug or an injection attempt.
 */
export const GuardianInviteCreateSchema = z
  .object({
    label: GuardianLabelSchema,
  })
  .strict();

export type GuardianInviteCreate = z.infer<typeof GuardianInviteCreateSchema>;
